import { ref, Ref } from "vue";

export type DocumentFileKey = 'file1' | 'file2' | 'file3';

const DOCUMENT_FILE_KEYS: DocumentFileKey[] = ['file1', 'file2', 'file3'];
const MAX_DOCUMENT_FILE_SIZE = 2 * 1024 * 1024;
const DOCUMENT_FILE_PATTERN = /\.(jpe?g|png|pdf)$/i;

/**
 * Выбор документов студента (JPG, JPEG, PNG, PDF до 2MB) с проверкой одинаковых имён.
 * files — реактивный объект, куда записываются выбранные файлы по ключам file1/file2/file3.
 */
export function useDocumentFiles(files: Record<string, any>) {
    const inputs: Record<DocumentFileKey, Ref<HTMLInputElement | null>> = {
        file1: ref(null),
        file2: ref(null),
        file3: ref(null),
    };

    function clearFile(type: DocumentFileKey) {
        if (inputs[type].value) {
            inputs[type].value.value = '';
        }
        files[type] = null;
    }

    function selectFile(e: Event, type: DocumentFileKey) {
        const file = (e.target as HTMLInputElement).files?.[0];
        if (!file) {
            return;
        }

        if (file.size > MAX_DOCUMENT_FILE_SIZE) {
            alert(`Размер файла превышает 2MB. Текущий размер: ${(file.size / (1024 * 1024)).toFixed(2)}MB`);
            clearFile(type);
            return;
        }

        if (!DOCUMENT_FILE_PATTERN.test(file.name)) {
            clearFile(type);
            alert('Неверный формат');
            return;
        }

        const isDuplicateName = DOCUMENT_FILE_KEYS.some((key) => key !== type && files[key]?.name === file.name);
        if (isDuplicateName) {
            alert('Файл с таким названием уже загружен');
            clearFile(type);
            return;
        }

        files[type] = file;
    }

    return {
        ...inputs,
        selectFile,
    };
}
